import React from "react";

const YellowCardOneButton: React.FC<{
    customText?: string | JSX.Element;
    buttonText?: string;
    linkUrl?: string;
    bgColor?: string;
    txtcolor?: string;
}> = ({
    customText = "Automate and simplify payments on WhatsApp today!",
    buttonText = "Get started Today",
    linkUrl = "https://app.gallabox.com/signup",
    bgColor = "bg-yellow-200",
    txtcolor = "text-yellow-800",
}) => {
    return (
        <section className="max-w-6xl px-4 lg:px-0 mx-auto py-10">
            <div style={{ borderRadius: "6px" }} className={`w-full h-40 ${bgColor}`}>
                <div className="flex flex-col lg:gap-4 gap-2 justify-center items-center px-4 lg:px-0 lg:py-8 py-4">
                    <h2 className={`${txtcolor} font-bold text-center lg:text-3xl text-lg`}>{customText}</h2>
                    <a
                        className="main-button outline-none focus:outline-none start-trial-btn hover:no-underline hover:shadow-lg transition duration-300 ease-in-out inline-flex items-center justify-center md:justify-start gap-1"
                        target="_blank"
                        href={linkUrl}
                        rel="noreferrer"
                    >
                        {buttonText}
                    </a>
                </div>
            </div>
        </section>
    );
};

export default YellowCardOneButton;
